import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Bancos } from 'src/app/classes/Bancos';
import { BancosService } from 'src/app/services/banco.service';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-bancos-forms',
  templateUrl: './bancos-forms.component.html',
  styleUrls: ['./bancos-forms.component.scss']
})
export class BancosFormsComponent implements OnInit {

  id:number;
  bancos: Bancos;
  bancoss: Bancos[];
  inserindo: boolean = false;
  carregando: boolean = false;
  form: any;
  public isSubmit: boolean;

  constructor(
    private bancosService: BancosService,
    private route: ActivatedRoute,
    private router: Router,
    private toasty: CustomToastyService,
    private utils : UtilsService) {
      this.route.params.subscribe(res => {
        this.id = res.id;
      });
    }

  ngOnInit() {
    this.bancos = new Bancos();
    if(this.router.url.search("inserir") > 0)
      this.bancos = new Bancos()
    else
      this.selecionarBancos();
  }

  selecionarBancos() {
    this.carregando = true;
    this.bancosService.ObterPorId(this.id).subscribe(res =>{
      this.bancos = res;
      this.carregando = false;
    },
    ex =>{
      this.utils.getErro(ex);
      this.carregando = false;
    })
  }

  save(form: any) {
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }
    this.carregando = true;

    if(this.bancos.Id > 0){
      this.bancosService.Atualizar(this.bancos.Id, this.bancos).subscribe(
        res => {
          this.toasty.show('Feito!', 'Banco alterado!', 'success');
          this.carregando = false;
          this.router.navigate(['/cadastros/bancos']);
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
      }
    else{

      this.bancosService.Inserir(this.bancos).subscribe(
        res => {
          this.toasty.show('Feito!', 'Banco cadastrado!', 'success');
          this.carregando = false;
          this.router.navigate(['/cadastros/bancos']);
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
      }
  }

  

  cancelar(){
    this.router.navigate(['/cadastros/bancos']);
  }

}
